import React, { useEffect, useState, useContext } from "react";

import "react-slideshow-image/dist/styles.css";
import { Slide } from "react-slideshow-image";

import { useNavigate } from "react-router-dom";
import { RedirectCode400 } from "../RedirectCode400";
import ModalAlertLabData from "../material/modal/ModalAlertLabData";

import design from "./Home.module.css";
import "../../asset/css_scss/public/home.css";
import * as publicApi from "../../service/publicApi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { extracThaiMonthYear, convertToThaiDate } from "../../utils/utils";
import logo__home from "../../asset/image/logo.svg";
import logo__Pookpun from "../../asset/image/new/logo.png";
import bg1 from "../../asset/image/new/bg1.png";
import bg2 from "../../asset/image/new/bg2.png";
import icon1 from "../../asset/image/new/pharma_icon1.svg";
import icon2 from "../../asset/image/new/pharma_icon2.svg";
import icon3 from "../../asset/image/new/pharma_icon3.svg";
import icon4 from "../../asset/image/new/pharma_icon4.svg";
import icon5 from "../../asset/image/new/hla-a31-01-01.svg";
import icon6 from "../../asset/image/new/hla-a13-01-01.svg";
import banner1 from "../../asset/image/new/banner1.png";
import banner2 from "../../asset/image/new/banner2.svg";
import banner3 from "../../asset/image/new/banner3.svg";
import banner4 from "../../asset/image/new/banner4.svg";
import book1 from "../../asset/image/new/book1.png";
import book2 from "../../asset/image/new/book2.png";
import book3 from "../../asset/image/new/book3.png";
import book4 from "../../asset/image/new/book4.png";
import { CurrentUserContext } from "../../App";

import peopleFilePDF from "../../asset/files/user_manual_general_public.pdf";
// import peopleFilePDF from "../../asset/files/ผูกพันธุ์ สำหรับประชาชน.pdf";
import doctorFilePDF from "../../asset/files/ผูกพันธุ์ สำหรับแพทย์และเภสัชกร.pdf";
import laboratoryFilePDF from "../../asset/files/ผูกพันธุ์ สำหรับห้องปฏิบัติการ.pdf";
import adminLaboratoryFilePDF from "../../asset/files/ผูกพันธุ์ สำหรับแอดมินห้องปฏิบัติการ.pdf";

import InspectionStatistics from "./InspectionStatistics/InspectionStatistics";

const slideImages = [
  {
    url: `${banner1}`,
    caption: "Slide 1",
  },
  {
    url: `${banner2}`,
    caption: "Slide 2",
  },
  {
    url: `${banner3}`,
    caption: "Slide 3",
  },
  {
    url: `${banner4}`,
    caption: "Slide 4",
  },
];
const Books = [
  {
    url: `${book1}`,
    name: "คู่มือการใช้งาน สำหรับประชาชน",
    link: peopleFilePDF,
  },
  {
    url: `${book2}`,
    name: "คู่มือการใช้งาน สำหรับแพทย์ หรือเภสัชกร",
    link: doctorFilePDF,
  },
  {
    url: `${book3}`,
    name: "คู่มือการใช้งาน สำหรับผู้ดูแลห้องปฏิบัติการ",
    link: laboratoryFilePDF,
  },
  {
    url: `${book4}`,
    name: "คู่มือการใช้งาน สำหรับผู้ปฏิบัติงานในห้องปฏิบัติการ",
    link: adminLaboratoryFilePDF,
  },
];

const Allergies = [
  {
    url: `${icon1}`,
    name: "HLA-B*58:01",
    title:
      "การตรวจ HLA-B*58:01 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยา ที่เกิดจากการได้รับยา Allopurinol",
    link: "/HLAB5801",
  },
  {
    url: `${icon2}`,
    name: "HLA-B*57:01",
    title:
      "การตรวจ HLA-B*57:01 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยา ที่เกิดจากการได้รับยา Abacavir",
    link: "/HLAB5701",
  },
  {
    url: `${icon3}`,
    name: "HLA-B*15:02",
    title:
      "การตรวจ HLA-B*15:02 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยา ที่เกิดจากการได้รับยา Carbamazepine",
    link: "/HLAB1502",
  },
  {
    url: `${icon4}`,
    name: "NAT2",
    title:
      "การตรวจ NAT2-Diplotype ตรวจยีนย่อยสลายยา Isoniacid เพื่อพิจารณาให้ยาในขนาด",
    link: "/NAT2",
  },
  {
    url: `${icon5}`,
    name: "HLA-A*31:01",
    title:
      "การตรวจ HLA-A*31:01 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยา ที่เกิดจากการได้รับยา Carbamazepine",
    link: "/HLAA3101",
  },
  {
    url: `${icon6}`,
    name: "HLA-B*13:01",
    title:
      "การตรวจ HLA-B*13:01 เพื่อหลีกเลี่ยงอาการผื่นแพ้ยา ที่เกิดจากการได้รับยา Dapsone",
    link: "/HLAB1301",
  },
];

function Home({ roleUser }) {
  const navigate = useNavigate();
  const { setIsMessage } = useContext(CurrentUserContext);
  const [inputValue, setInputValue] = useState("");
  const [checkDataSuccess, setCheckDataSuccess] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [announcementList, setAnnouncementList] = useState([]);
  const [newsList, setNewsList] = useState([]);
  const [articleList, setArticleList] = useState([]);
  const [slideBanner, setSlideBanner] = useState([]);
  const [loadingBanner, setLoadingBanner] = useState(true);

  const searchResult = async (pid) => {
    let res = await publicApi.searchResult(pid);
    if (res) {
      if (res["data"]["code"] === 200) {
        if (res["data"]["exists"]) {
          setCheckDataSuccess(true);
          setOpenModal(true);
        } else {
          setCheckDataSuccess(false);
          setOpenModal(true);
        }
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    }
  };

  const onClickSearchApiLab = () => {
    if (inputValue === "") {
      setIsMessage({ type: "warning", data: "กรุณากรอกข้อมูลก่อนค้นหา" });
    } else {
      searchResult(inputValue.replace(/-/g, ""));
    }
  };

  const extracThaiDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    return `${day}`;
  };

  const ViewAll = (data) => {
    if (data === "news") {
      navigate("/news");
    } else if (data === "article") {
      navigate("/article");
    } else if (data === "announcement") {
      navigate("/announcement");
    }
  };

  //get banner
  const getBannerList = async () => {
    const body = {
      page: 1,
      number_per_page: 4,
      sort: {
        publish_start_date: -1,
      },
    };
    await publicApi.getBannerList(body).then((res) => {
      if (res) {
        if (res["data"]["code"] === 200) {
          setSlideBanner(res["data"]["banner_list"]);
        } else if (res["data"]["code"] === 403) {
          setIsMessage({
            type: "warning",
            data: res["data"]["message_th"] || res["data"]["message"],
          });
        } else {
          setIsMessage({
            type: "warning",
            data: res["data"]["message_th"] || res["data"]["message"],
          });
        }
        setLoadingBanner(false);
      }
    });
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    //ประชาสัมพันธ์
    const getNewsList = async () => {
      const body = {
        type: "news",
        page: 1,
        number_per_page: 4,
        sort: {
          publish_start_date: -1,
        },
      };
      await publicApi.getContentList(body).then((res) => {
        if (res) {
          if (res["data"]["code"] === 200) {
            setNewsList(res["data"]["content_list"]);
          } else if (res["data"]["code"] === 403) {
            navigate(RedirectCode400());
          } else {
            setIsMessage({
              type: "warning",
              data: res["data"]["message_th"] || res["data"]["message"],
            });
          }
        }
      });
    };
    const getArticleList = async () => {
      const body = {
        type: "article",
        page: 1,
        number_per_page: 4,
        sort: {
          publish_start_date: -1,
        },
      };
      await publicApi.getContentList(body).then((res) => {
        if (res) {
          if (res["data"]["code"] === 200) {
            setArticleList(res["data"]["content_list"]);
          } else if (res["data"]["code"] === 403) {
            navigate(RedirectCode400());
          } else {
            setIsMessage({
              type: "warning",
              data: res["data"]["message_th"] || res["data"]["message"],
            });
          }
        }
      });
    };
    const getAnnouncementList = async () => {
      const body = {
        type: "announcement",
        page: 1,
        number_per_page: 4,
        sort: {
          publish_start_date: -1,
        },
      };
      await publicApi.getContentList(body).then((res) => {
        if (res) {
          if (res["data"]["code"] === 200) {
            setAnnouncementList(res["data"]["content_list"]);
          } else if (res["data"]["code"] === 403) {
            navigate(RedirectCode400());
          } else {
            setIsMessage({
              type: "warning",
              data: res["data"]["message_th"] || res["data"]["message"],
            });
          }
        }
      });
    };

    getNewsList();
    getArticleList();
    getAnnouncementList();
    getBannerList();
  }, [navigate, setIsMessage]);

  const formatThaiID = (id) => {
    const cleanID = id.replace(/[^0-9]/g, "");
    const parts = [];
    if (cleanID.length > 0) parts.push(cleanID.substring(0, 1));
    if (cleanID.length > 1) parts.push(cleanID.substring(1, 5));
    if (cleanID.length > 5) parts.push(cleanID.substring(5, 10));
    if (cleanID.length > 10) parts.push(cleanID.substring(10, 12));
    if (cleanID.length > 12) parts.push(cleanID.substring(12, 13));
    return parts.join("-");
  };

  return (
    <>
      <div>
        {openModal ? (
          <ModalAlertLabData
            onClose={() => {
              setOpenModal(false);
            }}
            // disabledIconX
            inputValue={inputValue}
            title={"ผลการตรวจสอบข้อมูล"}
            statusFindData={checkDataSuccess ? "HAVE DATA" : "NOT FOUND DATA"}
            detail={` ${
              checkDataSuccess
                ? "ท่านมีข้อมูลผลการตรวจในระบบผูกพันธุ์"
                : " ท่านไม่มีข้อมูลผลการตรวจในระบบผูกพันธุ์"
            }`}
          />
        ) : null}

        {/* <HeadBar menu={"home"} /> */}

        {loadingBanner === false ? (
          <div className="z-[2] xlg:pt-[95px] pt-[110px] xl:pt-[66px] relative items-center justify-center">
            <Slide
              transitionDuration={350}
              indicators={(index) => (
                <div className="indicator h-2 w-2 mx-1 rounded-full bg-gray-300 active:bg-black transition-all cursor-pointer">
                  {/* สไตล์ปกติของคุณ */}
                </div>
              )}
              scale={1}
              // indicators={true}
              nextArrow={
                <button className="flex items-center justify-center w-[35px] h-[35px] rounded-full mr-5 bg-white shadow-md">
                  <svg
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={2}
                    stroke="black"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4"
                  >
                    <path d="M9 5l7 7-7 7" />
                  </svg>
                </button>
              }
              prevArrow={
                <button className="flex items-center justify-center w-[35px] h-[35px] rounded-full ml-5 bg-white shadow-md">
                  <svg
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={2}
                    stroke="black"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4"
                  >
                    <path d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
              }
            >
              {slideBanner.map((slideImages, index) => (
                <div key={index} className="w-full">
                  <div className="z-4 w-full aspect-[7/2] select-none pointer-events-none">
                    <img
                      alt="Slide Banner"
                      className="w-full h-full object-contain"
                      draggable="false"
                      src={slideImages.url}
                    />
                  </div>
                </div>
              ))}

              {/* {slideImages.map((item, index) =>
                    (
                      <div key={index}>
                        <div className="z-4 w-full aspect-[7/2] select-none pointer-events-none">
                          <img
                            alt="Slide Banner"
                            className="w-full h-full object-contain"
                            draggable="false"
                            src={item.url}
                          />
                        </div>
                      </div>
                    )
                )} */}
            </Slide>
          </div>
        ) : (
          ""
        )}
        <div className="global-home-page">
          <div className="title-home-box">
            <div className="flex w-full justify-center items-center">
              <div className="flex flex-col text-black">
                <div className="sm:text-base w-full px-2 py-2 text-[22px] text-center font-bold">
                  แพลตฟอร์มรายงานผลการตรวจทางห้องปฏิบัติการ
                  กรมวิทยาศาสตร์การแพทย์
                </div>
                <div className="flex flex-col justify-center items-center w-full px-2 mb-5 rounded-lg border border-gray-300">
                  <div className="sm:text-sm sm:font-normal pt-6 text-lg font-bold">
                    สำหรับสมาชิกที่เคยใช้บริการแล้วกดค้นหาข้อมูลด้วยเลข 13 หลัก
                  </div>
                  <div
                    className={`flex flex-row justify-between items-center w-[95%] aspect-[29/2] mx-2 my-2 rounded-md bg-white border       ${
                      inputValue.length > 0 &&
                      inputValue.replace(/\D/g, "").length !== 13
                        ? "border-red-500"
                        : "border-black"
                    }
`}
                  >
                    <label htmlFor="id_card" className="sr-only">
                      เลขบัตรประจำตัวประชาชน
                    </label>
                    <input
                      id="id_card"
                      type="text"
                      className={` w-full px-4 rounded-md text-sm                          `}
                      placeholder="พิมพ์เลขบัตรประจำตัวประชาชน 13 หลัก"
                      onChange={(e) => {
                        setInputValue(e.target.value);
                      }}
                      value={formatThaiID(inputValue)}
                      maxLength={17}
                    />
                    <div
                      className="xsm:px-1 xsm:text-sm xsm:font-normal flex px-4 right-1 top-1 h-full justify-center items-center text-base cursor-pointer border-l border-black"
                      onClick={onClickSearchApiLab}
                    >
                      <FontAwesomeIcon
                        icon={faSearch}
                        className="w-3 h-3 mr-[5px]"
                      />
                      ค้นหา
                    </div>
                  </div>
                  <div className="sm:px-0 flex flex-col justify-center items-start w-full px-2">
                    <div className="sm:px-0 px-5 py-4">
                      <div className="sm:text-xs sm:font-normal text-sm font-bold">
                        หากท่านคิดว่าเคยได้รับการตรวจทางเภสัชพันธุศาสตร์
                        จากโรงพยาบาล
                      </div>
                      <div className="sm:text-xs sm:font-normal text-sm font-bold">
                        ท่านสามารถค้นหาข้อมูลการตรวจในระบบผูกพันธุ์
                        โดยกรอกเลขบัตรประจำตัวประชาชน 13 หลัก ในช่องนี้ได้เลยค่ะ
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <InspectionStatistics />

            {newsList.length > 0 ? (
              <>
                <span className="xl:text-2xl text-3xl font-bold">
                  ประชาสัมพันธ์
                </span>
                <div className="sm:gap-4 md:!grid-cols-1 lg:grid-cols-2 grid grid-flow-dense grid-cols-4 gap-7 my-4">
                  {newsList.map((news, index) => (
                    <div
                      key={index}
                      className="flex flex-col justify-start items-center cursor-pointer"
                      onClick={() => navigate(`/news/${news.content_id}`)}
                    >
                      <div className="overflow-hidden w-full h-[270px] rounded-md cursor-pointer">
                        <img
                          alt="Thumbnail News"
                          className={`h-full w-full border transition-transform dura tion-300 hover:scale-110 rounded-lg ${
                            news.thumbnail ? "object-cover" : "object-contain"
                          }`}
                          src={news.thumbnail ? news.thumbnail : logo__home}
                        />
                      </div>
                      <div className="flex flex-col items-center w-full pt-3">
                        {index === 0 && (
                          <div className="flex px-1 pt-3 w-full">
                            <div className="lg:text-[8px] lg:px-3 flex text-start px-4 py-1 text-[10px] text-white bg-red-500 rounded-[25px]">
                              New Update
                            </div>
                          </div>
                        )}
                        <span className="lg:text-xs px-1 py-3 w-full text-sm text-gray-500">
                          โพสต์เมื่อ{" "}
                          {convertToThaiDate(news.publish_start_date.date)}
                        </span>
                        <span
                          className={`xl:text-base px-1 w-full text-lg font-bold ${design.truncate}`}
                        >
                          {news.title}
                        </span>
                        <span
                          className="p-1 w-full text-sm underline cursor-pointer text-[#FF9768]"
                          onClick={() => navigate(`/news/${news.content_id}`)}
                        >
                          อ่านเพิ่มเติม
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="w-full flex justify-end">
                  <button
                    className="2md:px-5 2md:py-[6px] 2md:text-xs px-[40px] py-[13px] bg-[#4F9C9D] text-sm text-white text-nowrap rounded-3xl"
                    onClick={() => ViewAll("news")}
                  >
                    ดูทั้งหมด
                  </button>
                </div>
              </>
            ) : null}
          </div>

          <div className="w-full h-3 bg-gradient-to-r from-[#F1F9F5] via-[#F7FCFA] to-white"></div>

          <div className="title-home-box">
            <div className="xl:flex xl:flex-col grid grid-flow-col-dense grid-cols-2 gap-7 h-full">
              <div className="flex relative justify-center items-center cursor-pointer group">
                <div
                  className="overflow-hidden rounded-xl aspect-[6/7]"
                  onClick={() => navigate("/about")}
                >
                  <img
                    alt="Background Web Page"
                    className="h-full object-cover border-[1px] border-gray-200 transition-transform duration-300 group-hover:scale-105"
                    src={bg1}
                  />
                </div>
              </div>
              <div className="flex flex-col w-full">
                <div className="xl:flex-col xl:items-center flex flex-row w-full gap-2">
                  <img
                    className="lg:p-7 p-10 xl:w-40 xl:h-40  border border-gray-400 rounded-lg object-contain"
                    src={logo__Pookpun}
                    alt="Logo Pookpun"
                  />
                  <div className="2xl:text-2xl p-2 w-full text-3xl font-bold">
                    {" "}
                    แพลตฟอร์มรายงาน ผลการตรวจทางห้องปฏิบัติการ
                    กรมวิทยาศาสตร์การแพทย์{" "}
                  </div>
                </div>
                <div className="sm:text-base py-4 w-full h-full text-lg">
                  กรมวิทยาศาสตร์การแพทย์
                  นำร่องให้บริการแก่ประชาชนสามารถเข้าถึงผลการตรวจทางเภสัชพันธุศาสตร์
                  เพื่อป้องกันการแพ้ยารุนแรงแบ่งออกเป็น 4 การทดสอบ ได้แก่ <br />
                  1.การตรวจ HLA-B*58:01 สำหรับกลุ่มผู้ป่วยที่ได้รับยา
                  Allopurinol <br />
                  2.การตรวจ HLA-B*15:02 สำหรับกลุ่มผู้ป่วยที่ได้รับยา
                  Carbamazepine <br />
                  3.การตรวจ HLA-B*57:01 สำหรับกลุ่มผู้ป่วยที่ได้รับยา Abacavir{" "}
                  <br />
                  4.การตรวจยีนย่อยสลายยา NAT2 ในผู้ป่วยโรควัณโรคที่ได้รับยา
                  Isoniazid <br />
                  5.การตรวจ HLA-A*31:01 สำหรับกลุ่มผู้ป่วยที่ได้รับยา
                  Carbamazepine <br />
                  6.การตรวจ HLA-B*13:01 สำหรับกลุ่มผู้ป่วยที่ได้รับยา Dapsone{" "}
                  <br />
                  และการทดสอบทางพันธุกรรมอื่น ๆ เช่น การตรวจการกลายพันธุ์ของยีน
                  BRCA1/BRCA2 การตรวจธาลัสซีเมีย
                  <span
                    className="flex w-[75px] py-2 text-sm underline cursor-pointer text-[#FF9768]"
                    onClick={() => navigate("/about")}
                  >
                    อ่านเพิ่มเติม
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full h-3 bg-gradient-to-r from-[#F1F9F5] via-[#F7FCFA] to-white"></div>
          <div className="title-home-box">
            <h2 className="xl:text-2xl text-3xl font-bold">
              คู่มือการใช้งานระบบ
            </h2>
            <div className="xsm:flex xsm:flex-col sm:gap-2 lg:grid-cols-2 lg:grid-rows-2 grid grid-flow-col-dense grid-cols-4 gap-7 my-4">
              {Books.map((book, index) => {
                return (
                  <a
                    key={index}
                    href={book["link"]}
                    target="_blank"
                    rel="noreferrer"
                    className="2md:px-3 lg:px-10 flex flex-col justify-start items-center w-full text-black cursor-pointer"
                  >
                    <div className="overflow-hidden rounded-md border border-gray-400">
                      <img
                        className="w-full object-cover border-[1px] border-gray-200"
                        src={book.url}
                        alt="Manual User Book"
                      />
                    </div>
                    <span className="xsm:text-base flex py-2 w-full text-start text-lg font-bold">
                      {book.name}
                    </span>
                    <span className="p-1 w-full text-sm underline text-[#FF9768]">
                      อ่านเพิ่มเติม
                    </span>
                  </a>
                );
              })}
            </div>
          </div>
          {articleList.length > 0 ? (
            <>
              <div className="w-full h-3 bg-gradient-to-r from-[#F1F9F5] via-[#F7FCFA] to-white"></div>
              <div className="title-home-box">
                <span className="xl:text-2xl text-3xl font-bold">บทความ</span>
                <div className="xsm:flex xsm:flex-col sm:gap-4 lg:grid-cols-2 grid grid-flow-dense grid-cols-4 gap-7 my-4">
                  {articleList.map((article, index) => (
                    <div
                      key={index}
                      className="flex flex-col justify-start items-center cursor-pointer"
                      onClick={() => navigate(`/article/${article.content_id}`)}
                    >
                      <div className="overflow-hidden w-full h-[270px] rounded-md">
                        <img
                          alt="Thumbnail article"
                          className="w-full h-full object-contain border-[1px] border-gray-200 transition-transform duration-300 hover:scale-110"
                          src={
                            article.thumbnail ? article.thumbnail : logo__home
                          }
                        />
                      </div>
                      <div className="flex flex-col items-center w-full py-3">
                        {index === 0 && (
                          <div className="flex px-1 pt-3 w-full">
                            <div className="lg:text-[8px] lg:px-3 flex text-start px-4 py-1 text-[10px] text-white bg-red-500 rounded-[25px]">
                              New Update
                            </div>
                          </div>
                        )}
                        <span className="lg:text-xs px-1 py-3 w-full text-sm text-gray-500">
                          โพสต์เมื่อ{" "}
                          {convertToThaiDate(article.publish_start_date.date)}
                        </span>
                        <span
                          className={`xl:text-base px-1 w-full text-lg font-bold ${design.truncate}`}
                        >
                          {article.title}
                        </span>
                        <span
                          className="p-1 w-full text-sm underline cursor-pointer text-[#FF9768]"
                          onClick={() =>
                            navigate(`/article/${article.content_id}`)
                          }
                        >
                          อ่านเพิ่มเติม
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="w-full flex justify-end">
                  <button
                    className="2md:px-5 2md:py-[6px] 2md:text-xs px-[40px] py-[13px] bg-[#4F9C9D] text-sm text-white text-nowrap rounded-3xl"
                    onClick={() => navigate("/article")}
                  >
                    ดูทั้งหมด
                  </button>
                </div>
              </div>
            </>
          ) : null}
          {announcementList.length > 0 ? (
            <>
              <div className="w-full h-3 bg-gradient-to-r from-[#F1F9F5] via-[#F7FCFA] to-white"></div>
              <div className="title-home-box">
                <span className="xl:text-2xl text-3xl font-bold">ประกาศ</span>
                <div className="flex flex-col w-full bg-gray-200 gap-[2px] my-4">
                  {announcementList.map((announcement, index) => (
                    <div
                      key={index}
                      className="sm:items-center flex flex-row w-full justify-between items-start gap-4 py-4 bg-white cursor-pointer"
                      onClick={() =>
                        navigate(`/announcement/${announcement.content_id}`)
                      }
                    >
                      <div className="2sm:flex-col-reverse 2sm:items-center flex flex-row w-[10%] gap-1 justify-start items-start">
                        <div className="flex flex-col justify-center items-center">
                          <span className="xl:text-xl flex text-2xl text-red-500 font-bold">
                            {extracThaiDate(
                              announcement.publish_start_date.date,
                            )}
                          </span>
                          <span className="xl:text-xs flex text-sm text-nowrap">
                            {extracThaiMonthYear(
                              announcement.publish_start_date.date,
                            )}
                          </span>
                        </div>
                        {index === 0 && (
                          <div className="lg:px-2 lg:py-[2px] lg:text-[8px] mt-2 px-4 py-1 bg-red-500 text-xs text-white text-center rounded-[25px]">
                            New
                          </div>
                        )}
                      </div>
                      <div className="xl:text-sm xl:px-5pr-5 text-lg font-bold w-full text-start">
                        {announcement.title}
                      </div>
                      <button className="md:text-[11px] p-1 w-[10%] text-sm underline cursor-pointer text-end text-nowrap text-[#FF9768]">
                        อ่านเพิ่มเติม
                      </button>
                    </div>
                  ))}
                </div>
                <div className="w-full flex justify-end">
                  <button
                    className="2md:px-5 2md:py-[6px] 2md:text-xs px-[40px] py-[13px] bg-[#4F9C9D] text-sm text-white text-nowrap rounded-3xl"
                    onClick={() => ViewAll("announcement")}
                  >
                    ดูทั้งหมด
                  </button>
                </div>
              </div>
            </>
          ) : null}
        </div>
        <div
          className={`2lg:aspect-[5/3] flex relative w-full aspect-[5/2] min-h-[475px] bg-cover`}
          style={{ backgroundImage: `url(${bg2})` }}
        >
          <div className="md:px-10 absolute px-[110px] py-[35px] w-full h-full">
            <span className="xl:text-2xl text-3xl font-bold">
              เภสัชพันธุศาสตร์
            </span>
            <div className="xsm:grid-rows-1 2lg:grid-cols-1 grid grid-flow-col-dense grid-cols-2 grid-rows-3 gap-4 py-4 w-full h-[85%]">
              {Allergies.map((allergy, index) => (
                <div
                  key={index}
                  className={`xsm:flex-col xsm:items-center flex flex-row gap-4 cursor-pointer ${
                    index >= 2 ? " 2lg:hidden" : "flex"
                  }${index >= 1 ? " sm:hidden" : "flex"}`}
                  onClick={() =>
                    navigate(`information/pharmacogeneticTest${allergy.link}`)
                  }
                >
                  <div className="xsm:p2 xsm:h-[50%] 2lg:max-w-[200px] aspect-square p-5 justify-items-center bg-white rounded-lg">
                    <img
                      alt="Thumbnail Allergy"
                      className="h-full object-scale-down"
                      src={allergy.url}
                    />
                  </div>
                  <div className="flex flex-col gap-2 w-full h-full">
                    <span className="xl:text-xl flex text-3xl font-bold">
                      {allergy.name}
                    </span>
                    <span className="xl:text-base flex text-lg">
                      {allergy.title}
                    </span>
                    <span className="flex text-sm underline text-[#FF9768]">
                      อ่านเพิ่มเติม
                    </span>
                  </div>
                </div>
              ))}
            </div>
            <div className="w-full flex justify-end">
              <button
                className="2md:px-5 2md:py-[6px] 2md:text-xs px-[40px] py-[13px] bg-[#4F9C9D] text-sm text-white text-nowrap rounded-3xl"
                onClick={() => navigate("/information/pharmacogeneticTest")}
              >
                ดูทั้งหมด
              </button>
            </div>
          </div>
        </div>

        {roleUser === "Laboratory" ||
        roleUser === "Admin" ||
        roleUser === "Medical" ||
        roleUser === "Patient" ||
        roleUser === "Hospital"
          ? ""
          : ""}
      </div>
    </>
  );
}

export default Home;
